import { Component, OnInit, Output, EventEmitter, OnDestroy, Renderer2, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DataService } from '../services/data.service';
import { ModalService } from '../_modal';
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormGroup } from '@angular/forms';
import { UserService } from '../services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ValidationMessages } from '../validation-messages';
import { DOCUMENT } from '@angular/common';

declare const embeddedservice_bootstrap: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css', '../../assets/css/bootstrap.css', '../../assets/css/default.css', '../../assets/css/AdminLTE.css', '../../assets/css/_all-skins.css', '../../assets/css/fSelect.css', '../../assets/datatables.net/dataTables.bootstrap.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Output() loadNgOnInit = new EventEmitter();
  adminFormH: UntypedFormGroup;
  submittedh: any = false;
  serverEmailh = false;
  activeMenu: any;
  loggedStatus: any;
  loggedUserName: any;
  loggedUserDName: any;
  loggedPmaxUser: any;
  loggedUserRole: any;
  loggedUserId: any;
  hNotifications: any = [];
  hANotifications: any = [];
  unreadCount = '0';
  loginUserName: any;
  loginPassword: any;
  loginRemberMe: any;
  mySubscription: any;
  backgroundColor = '';
  logo_path: any;
  canhaveUserBroker:any = '0';
  isProduction:Boolean = false;
  domainname: any;
  buttoncolor: any;
  textColor:any;
  appversion: string;
  isLroAdmin: string;
  updateBrokerPassForm: FormGroup;
  confirmmailerror: boolean = false;
  submittedFA: boolean = false;
  masterSettings:any = [];
  show_release_notes:string='no';  
  show_master_settings:string='no';
  constructor(private formBuilder: UntypedFormBuilder, public userService: UserService, private spinner: NgxSpinnerService, public router: Router, private modalService: ModalService, public dataService: DataService,private _renderer: Renderer2,@Inject(DOCUMENT) private _document,) {
    
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
       
        this.router.navigated = false;
      }
    });
  }
  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }

  ngOnInit() {  
    if (localStorage.getItem('wholesalerInfoObJ') !== null) {
      let wholesalerInfoArray = JSON.parse(localStorage.getItem('wholesalerInfoObJ'));
      if (wholesalerInfoArray.output == 'success')  {
        this.backgroundColor = wholesalerInfoArray.wholesalerInfo[0].wi_header_bg_color_code;
        this.logo_path = wholesalerInfoArray.wholesalerInfo[0].wi_logo_s3_path;
        this.textColor = wholesalerInfoArray.wholesalerInfo[0].wi_text_bg_color_code;
        this.domainname = wholesalerInfoArray.wholesalerInfo[0].wi_domain;
        this.buttoncolor = wholesalerInfoArray.wholesalerInfo[0].wi_button_bg_color_code;
        // #3468c1 !important
        
      }
    }
    else {
      this.logo_path = 'assets/images/logo.png?v='+ValidationMessages.logoVersion;
      $('.layout-top-nav').addClass('skin-blue');
      $('.navbar-brand').removeClass('normandy');
    }

    var href = this.router.url;
    this.loggedUserDName = localStorage.getItem('u_name');
    this.loggedUserName = localStorage.getItem('u_email');
    this.loggedUserRole = localStorage.getItem('u_ur_id');
    this.loggedPmaxUser = localStorage.getItem('wholesalebroker');
    this.canhaveUserBroker = localStorage.getItem('canhaveUserBroker');
    this.loggedUserId = localStorage.getItem('u_id');
    this.loginUserName = localStorage.getItem('loginUserName');
    this.loginPassword = localStorage.getItem('loginPassword');
    this.loginRemberMe = localStorage.getItem('loginRememberme');
    if(localStorage.getItem('u_lro_admin') != undefined && localStorage.getItem('u_lro_admin') != null && localStorage.getItem('u_lro_admin') != ''){
        this.isLroAdmin = localStorage.getItem('u_lro_admin');
    }
    this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
    this.dataService.currentHeaderDisplayName.subscribe(status => this.loggedUserName = status);


var environmentt = window.location.hostname;
if(environmentt == ValidationMessages.productionUrl || environmentt ==  ValidationMessages.productionUrlWithWww || environmentt == ValidationMessages.productionNormandyDomain || environmentt == ValidationMessages.productionCanopyDomain || environmentt == ValidationMessages.productionPbibinsDomain){
  localStorage.setItem('View_tab', '0');
  if (localStorage.getItem('wholesalerInfoObJ') !== null) {
    $('.layout-top-nav').addClass('skin-blue');
    this.backgroundColor = this.backgroundColor + '! important';
    $('.navbar-static-top').attr('style', 'background-color:'+ this.backgroundColor);
  }
  this.isProduction = true
}else{
  localStorage.setItem('View_tab', '1');

  $('.layout-top-nav').addClass('skin-blue');
  this.backgroundColor = '#3468c1 ! important';
  $('.navbar-static-top').attr('style', 'background-color:'+ this.backgroundColor);
  
  this.isProduction = false
}
if(localStorage.getItem('u_ur_id') == '3'){
  this.loadSalesforceChatbot();   
}

    this.adminFormH = this.formBuilder.group({
      u_id: 0,
      u_name: ['', Validators.required],
      u_email: ['', [Validators.required, Validators.email]],
      u_password: ''
    });

    var postData = {};
    postData['u_id'] = localStorage.getItem('u_id');
    postData['type'] = 1;

    this.updateBrokerPassForm = this.formBuilder.group({
        up_pass: ['', Validators.required],
        up_conform_pass: ['', Validators.required]
    });


    this.getMasterSettings();
  }

  get fh() { return this.adminFormH.controls; }
  get ubp() { return this.updateBrokerPassForm.controls; }

  closeModalH(id: any) {
    this.modalService.close(id);
  }

  markAllAsRead() {
    this.spinner.show();
    this.userService.updateNotifications(this.loggedUserId, 0, 1).subscribe(() => {
      var postData = {};
      postData['u_id'] = localStorage.getItem('u_id');
      postData['type'] = 1;
      this.userService.getNotifications(postData).subscribe(data => {
        this.dataService.changeCurrentNotifications(data.notifications);
        this.dataService.currentNotifications.subscribe(status => this.hNotifications = status);
        this.dataService.changecurrentUnreadNCount(data.unreadCount);
        this.dataService.currentUnreadNCount.subscribe(status => this.unreadCount = status);
        this.spinner.hide();
      });
    });
  }

  markAllAsReadPop() {
    this.spinner.show();
    this.userService.updateNotifications(this.loggedUserId, 0, 1).subscribe(() => {
      var postData = {};
      postData['u_id'] = localStorage.getItem('u_id');
      postData['type'] = 1;
      this.userService.getNotifications(postData).subscribe(data => {
        this.dataService.changeCurrentNotifications(data.notifications);
        this.dataService.currentNotifications.subscribe(status => this.hNotifications = status);
        this.dataService.changecurrentUnreadNCount(data.unreadCount);
        this.dataService.currentUnreadNCount.subscribe(status => this.unreadCount = status);

        var postDataa = {};
        postDataa['u_id'] = localStorage.getItem('u_id');
        postDataa['type'] = 2;
        this.userService.getNotifications(postDataa).subscribe(data => {
          this.hANotifications = data.notifications;
          this.spinner.hide();
        });

      });
    });
  }


  closeNotificationPop() {
    this.modalService.close('view-all-notifications');
  }

  openNotificationPop() {
    this.spinner.show();
    var postData = {};
    postData['u_id'] = localStorage.getItem('u_id');
    postData['type'] = 2;
    this.userService.getNotifications(postData).subscribe(data => {
      this.hANotifications = data.notifications;
      this.modalService.open('view-all-notifications');
      this.spinner.hide();
    });

  }

  saveAdminH() {
    this.serverEmailh = false;
    this.submittedh = true;
    if (this.adminFormH.invalid) {
      return;
    }
    var postData = {};
    postData = this.adminFormH.value;
    postData['type'] = 1;
    postData['loggedUserRole'] = localStorage.getItem('u_ur_id');
    this.spinner.show();
    this.userService.saveAdmin(postData).subscribe(data => {
      this.spinner.hide();
      if (data.output == 0) {
        this.serverEmailh = true;
      } else {
        this.modalService.close('add-edit-modal-header');
        localStorage.setItem('u_email', this.adminFormH.value.u_email);
        localStorage.setItem('u_name', this.adminFormH.value.u_name);
        this.dataService.changeCurrentHeaderDisplayName(this.adminFormH.value.u_email);
        this.dataService.currentHeaderDisplayName.subscribe(status => this.loggedUserName = status);
      }
    });
  }

  goToHome() {
    if (this.loggedUserName == localStorage.getItem('u_email')) {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      if (this.loggedUserRole == 1 || this.loggedUserRole == 2) {
        this.goToQuotes();
      } else {
        this.goToQuotes();
      }
    } else {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      if (typeof localStorage.getItem('u_id') != 'undefined' && localStorage.getItem('u_id') != null && localStorage.getItem('u_id') != 'null' && localStorage.getItem('u_id') != "") {
        if (this.loggedUserRole == 1 || this.loggedUserRole == 2) {
          this.router.navigate(['/quotes']);
        } else {
          this.goToQuotes();
        }
      } else {
        this.logoutConfirm();
      }
    }
  }

  openQuoteNotPopup(quoteId: any, notifiId: any) {
    this.modalService.close('view-all-notifications');
    this.openQuote(quoteId, notifiId);
  }

  openQuoteHistoryNotpopup(quoteId: any, notifiId: any) {
    this.modalService.close('view-all-notifications');
    this.openQuoteHistory(quoteId, notifiId);
  }

  openQuoteHistory(quoteId: any, notifiId: any) {
    this.spinner.show();
    this.userService.updateNotifications(this.loggedUserId, quoteId, 4).subscribe(() => {
      localStorage.setItem('active_tab', '2');
      this.dataService.changeCurrentHeaderActive('2');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      localStorage.setItem('new_quote_id', '2');
      localStorage.setItem('qu_id', quoteId);
      this.dataService.changecurrentBreadcrumQuote(quoteId);
      var postData = {};
      postData['u_id'] = localStorage.getItem('u_id');
      postData['type'] = 1;
      this.userService.getNotifications(postData).subscribe(data => {
        this.dataService.changeCurrentNotifications(data.notifications);
        this.dataService.currentNotifications.subscribe(status => this.hNotifications = status);
        this.dataService.changecurrentUnreadNCount(data.unreadCount);
        this.dataService.currentUnreadNCount.subscribe(status => this.unreadCount = status);
        if (this.router.url.includes('/quote-history')) {
          
          localStorage.setItem('previousQuoteId', localStorage.getItem('currentQuoteId'));
          localStorage.setItem('currentQuoteId', quoteId);
        
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/quote-history', quoteId])
          );
        }
        else {
          this.router.navigate(['/quote-history', quoteId]);
        }
        this.spinner.hide();
      });
    });
  }

  openQuote(quoteId: any, notifiId: any) {
    this.spinner.show();
    this.userService.updateNotifications(this.loggedUserId, notifiId, 2).subscribe(() => {
      localStorage.setItem('active_tab', '2');
      this.dataService.changeCurrentHeaderActive('2');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      localStorage.setItem('new_quote_id', '2');
      localStorage.setItem('qu_id', quoteId);
      this.dataService.changecurrentBreadcrumQuote(quoteId);
      var postData = {};
      postData['u_id'] = localStorage.getItem('u_id');
      postData['type'] = 1;
      this.userService.getNotifications(postData).subscribe(data => {
        this.dataService.changeCurrentNotifications(data.notifications);
        this.dataService.currentNotifications.subscribe(status => this.hNotifications = status);
        this.dataService.changecurrentUnreadNCount(data.unreadCount);
        this.dataService.currentUnreadNCount.subscribe(status => this.unreadCount = status);
        if (this.router.url.includes('/quote-summary')) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/quote-summary', quoteId])
          );
        }
        else {
          this.router.navigate(['/quote-summary', quoteId]);
        }
        this.spinner.hide();
      });
    });
  }

  goToQuotes() {
    if (this.loggedUserName == localStorage.getItem('u_email')) {
      localStorage.setItem('active_tab', '2');
      this.dataService.changeCurrentHeaderActive('2');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      if (this.loggedUserRole == 3) {
        localStorage.setItem('brokerViewId', this.loggedUserId);
        if(localStorage.getItem('wholesalebroker') == '1' || localStorage.getItem('canhaveUserBroker') == '1' || localStorage.getItem('checkDisplayQuotes') == '1'){
          this.router.navigate(['/wbroker-quotes']);
        }else{
          this.router.navigate(['/broker-quotes']);
        }
       
      } else {
       localStorage.setItem('isReloadCom', '1');
        this.router.navigate(['/quotes']);
      }
    } else {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      if (typeof localStorage.getItem('u_id') != 'undefined' && localStorage.getItem('u_id') != null && localStorage.getItem('u_id') != 'null' && localStorage.getItem('u_id') != "") {
        this.router.navigate(['/home']);
      } else {
        this.logoutConfirm();
      }
    }
  }

  goToBrokers() {
    this.router.navigate(['/brokers']);
    if (this.loggedUserName == localStorage.getItem('u_email')) {
      localStorage.setItem('active_tab', '3');
      this.dataService.changeCurrentHeaderActive('3');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      this.router.navigate(['/brokers']);
    } else {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      if (typeof localStorage.getItem('u_id') != 'undefined' && localStorage.getItem('u_id') != null && localStorage.getItem('u_id') != 'null' && localStorage.getItem('u_id') != "") {
        this.router.navigate(['/home']);
      } else {
        this.logoutConfirm();
      }
    }
  }

  goToClients() {
    if (this.loggedUserName == localStorage.getItem('u_email')) {
      localStorage.setItem('active_tab', '4');
      this.dataService.changeCurrentHeaderActive('4');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      this.router.navigate(['/clients']);
    } else {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      if (typeof localStorage.getItem('u_id') != 'undefined' && localStorage.getItem('u_id') != null && localStorage.getItem('u_id') != 'null' && localStorage.getItem('u_id') != "") {
        this.router.navigate(['/home']);
      } else {
        this.logoutConfirm();
      }
    }

  }

  goToAdmins() {
    if (this.loggedUserName == localStorage.getItem('u_email')) {
      localStorage.setItem('active_tab', '5');
      this.dataService.changeCurrentHeaderActive('5');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      this.router.navigate(['/admins']);
    } else {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      if (typeof localStorage.getItem('u_id') != 'undefined' && localStorage.getItem('u_id') != null && localStorage.getItem('u_id') != 'null' && localStorage.getItem('u_id') != "") {
        this.router.navigate(['/home']);
      } else {
        this.logoutConfirm();
      }
    }
  }

  goToClaims() {
    if (this.loggedUserName == localStorage.getItem('u_email')) {
      localStorage.setItem('active_tab', '9');
      this.dataService.changeCurrentHeaderActive('9');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      this.router.navigate(['/old-list/1']);
    } else {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      if (typeof localStorage.getItem('u_id') != 'undefined' && localStorage.getItem('u_id') != null && localStorage.getItem('u_id') != 'null' && localStorage.getItem('u_id') != "") {
        this.router.navigate(['/home']);
      } else {
        this.logoutConfirm();
      }
    }
  }

  goToTutorials() {
    if (this.loggedUserName == localStorage.getItem('u_email')) {
      localStorage.setItem('active_tab', '10');
      this.dataService.changeCurrentHeaderActive('10');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      this.router.navigate(['/tutorials']);
    } else {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      if (typeof localStorage.getItem('u_id') != 'undefined' && localStorage.getItem('u_id') != null && localStorage.getItem('u_id') != 'null' && localStorage.getItem('u_id') != "") {
        this.router.navigate(['/home']);
      } else {
        this.logoutConfirm();
      }
    }
  }
  goToPayments() {
    if (this.loggedUserName == localStorage.getItem('u_email')) {
      localStorage.setItem('active_tab', '11');
      this.dataService.changeCurrentHeaderActive('11');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      this.router.navigate(['/payments-tab']);
    } else {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      if (typeof localStorage.getItem('u_id') != 'undefined' && localStorage.getItem('u_id') != null && localStorage.getItem('u_id') != 'null' && localStorage.getItem('u_id') != "") {
        this.router.navigate(['/home']);
      } else {
        this.logoutConfirm();
      }
    }
  }

  logoutPortal() {
    this.modalService.open('logout-modal');
  }

  logoutConfirmCancel() {
    this.modalService.close('logout-modal');
  }

  logoutConfirm() {
    this.spinner.show();
    this.modalService.close('logout-modal');
    this.loginUserName = localStorage.getItem('loginUserName');
    this.loginPassword = localStorage.getItem('loginPassword');
    this.loginRemberMe = localStorage.getItem('loginRememberme');
    this.appversion = localStorage.getItem("appversion");  
    localStorage.clear();

    localStorage.setItem('active_tab', '1');


    
    localStorage.setItem('loginUserName', this.loginUserName);
    localStorage.setItem('loginPassword', this.loginPassword);
    localStorage.setItem('loginRememberme', this.loginRemberMe);
    localStorage.setItem("appversion", this.appversion);
   
    this.spinner.hide();

 
    window.location.href = "/home";
  }

  goToMailTemp() {
    localStorage.setItem('active_tab', '0');
    this.dataService.changeCurrentHeaderActive('0');
    this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
    this.router.navigate(['/mail-templates']);
  }

  goToMailSign() {
    localStorage.setItem('active_tab', '0');
    this.dataService.changeCurrentHeaderActive('0');
    this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
    this.router.navigate(['/mail-signatures']);
  }

  goToReports() {
    localStorage.setItem('active_tab', '8');
    this.dataService.changeCurrentHeaderActive('8');
    this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
    this.router.navigate(['/reports']);
  }

  goToProfile() {
    if (this.loggedUserRole == 3) {
      localStorage.setItem('active_tab', '0');
      this.dataService.changeCurrentHeaderActive('0');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      localStorage.setItem('brokerViewId', this.loggedUserId);
      this.router.navigate(['/broker']);
    } else if (this.loggedUserRole == 2) {
      this.modalService.open('add-edit-modal-header');
      this.adminFormH.patchValue({
        u_id: this.loggedUserId,
        u_name: localStorage.getItem('u_name'),
        u_email: localStorage.getItem('u_email'),
        u_password: '',
      });
    }
  }

  goToDQuotes() {
    localStorage.setItem('active_tab', '2');
    this.dataService.changeCurrentHeaderActive('2');
    this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
    this.router.navigate(['/quote-tab']);
  }

  goToDSQuotes() {
    localStorage.setItem('active_tab', '2');
    this.dataService.changeCurrentHeaderActive('2');
    this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
    this.router.navigate(['/quote-tab-search']);
  }

    goToJotForm(){
        this.router.navigate(['/jot-form']);
    }
    navbarcollapse(){
  
    $('.navbar-collapse').removeClass('in');
    $('.navbar-toggle').addClass('collapsed');
    
    }

    openChangePasswordModel() {
        this.modalService.open('change-pass-modal');
    }

    closeChangePasswordModel() {
        this.confirmmailerror = false;
        this.submittedFA = false;
        this.modalService.close('change-pass-modal');
    }

    changePassword() {
        this.submittedFA = true;
        if (this.updateBrokerPassForm.invalid) {
            return;
        }

        if (this.updateBrokerPassForm.value.up_pass != this.updateBrokerPassForm.value.up_conform_pass) {
            this.confirmmailerror = true;
            return;
        }
        this.submittedFA = false;
        this.confirmmailerror = false;
        var postdata = {};
        postdata['updateBrokerPassForm'] = this.updateBrokerPassForm.value;
        postdata['typeOfUpdate'] = 0;
        postdata['brokerId'] = this.loggedUserId;
        postdata['loggedUserId'] = this.loggedUserId;
        postdata['u_email'] = this.loggedUserName;
        this.spinner.show();
        this.userService.brokerUpdatePassword(postdata).subscribe(data => {
            this.spinner.hide();
            this.modalService.close('change-pass-modal');
            this.modalService.open('warning-modal5');
            this.updateBrokerPassForm.reset();
        });
    }

    onChangePassword() {
        this.confirmmailerror = false;
        this.submittedFA = false;
    }

    closeWarnningModal() {
        this.modalService.close('warning-modal5');
    }

    goToReleaseNotes() {
      localStorage.setItem('active_tab', '12');
      this.dataService.changeCurrentHeaderActive('12');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      this.router.navigate(['/release-notes']);
    }

    goToMasterSettings() {
      localStorage.setItem('active_tab', '13');
      this.dataService.changeCurrentHeaderActive('13');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      this.router.navigate(['/master-settings']);
    }

    getMasterSettings(){
      this.userService.fetchMasterSettings().subscribe(data => {
        this.masterSettings = data;
        if(data?.show_release_notes_module != undefined && data?.show_release_notes_module != null && data?.show_release_notes_module != ''){
          this.show_release_notes = data?.show_release_notes_module ? data?.show_release_notes_module:'no';
        }
        
        if(data?.show_master_settings_module != undefined && data?.show_master_settings_module != null && data?.show_master_settings_module != ''){
          this.show_master_settings = data?.show_master_settings_module ? data?.show_master_settings_module:'no';
        }
        
      });
    }

    loadSalesforceChatbot(){
      
    	var environmentt = window.location.hostname;

		if(environmentt == 'localhost'){
			return false;
		}

    const productionUrls = [
			ValidationMessages.productionUrl,
			ValidationMessages.productionUrlWithWww,
			ValidationMessages.productionNormandyDomain,
			ValidationMessages.productionCanopyDomain,
			ValidationMessages.productionPbibinsDomain
		];
		
      	if (productionUrls.includes(environmentt)) {
			    var messageJsUrl = 'https://shieldcommercialinsuranceservices.my.site.com/ESWRaterMessagingChatw1774894964189/assets/js/bootstrap.min.js';
        	var instance_type = 'prod';
      	}else{          
        	var messageJsUrl  = 'https://shieldcommercialinsuranceservices--qa.sandbox.my.site.com/ESWRaterQueueMessaging1765969949504/assets/js/bootstrap.min.js'; 
          	var instance_type = 'stag';
      	}

        const script = document.createElement('script');
        script.src = messageJsUrl;
        script.type = 'text/javascript';
        script.onload = () => this.initEmbeddedMessaging(instance_type);
		
        document.body.appendChild(script);
    }

	private initEmbeddedMessaging(type = 'prod'): void {
		try {

			embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'

			//Sets the auto-population of pre-chat form fields			
			const handleEmbeddedMessagingReady = () => {
				embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
					_firstName: {
						value: localStorage.getItem('u_first_name'),
						required:true,
						isEditableByEndUser: true
					},
					_lastName: {
						value: localStorage.getItem('u_last_name'),
						required:true,
						isEditableByEndUser: true
					},
					_email: {
						value: localStorage.getItem('u_email'),
						required:true,
						isEditableByEndUser: true
					}
				});

				window.removeEventListener(
					'onEmbeddedMessagingReady',
					handleEmbeddedMessagingReady
				);
			};

			// Register listener BEFORE init
			window.addEventListener(
				'onEmbeddedMessagingReady',
				handleEmbeddedMessagingReady
			);

			if(type == 'prod'){
				embeddedservice_bootstrap.init(
					'00D8c000007CdNO',
					'Rater_Messaging_Chat_with_Bot',
          'https://shieldcommercialinsuranceservices.my.site.com/ESWRaterMessagingChatw1774894964189',
					{
						scrt2URL: 'https://shieldcommercialinsuranceservices.my.salesforce-scrt.com'
					}
				);
			}else{
				embeddedservice_bootstrap.init(
					'00DDN0000008jQF',
					'Rater_Queue_Messaging_Chat',
					'https://shieldcommercialinsuranceservices--qa.sandbox.my.site.com/ESWRaterQueueMessaging1765969949504',
					{
						scrt2URL: 'https://shieldcommercialinsuranceservices--qa.sandbox.my.salesforce-scrt.com'
					}
				);
			}
			
		} catch (err) {
      console.error('Error loading Embedded Messaging: ', err);
		}
	}
}
